import { useApolloClient } from "@apollo/client";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { ProductosDtSourceImplGql } from "../../data/datasources/ProductosDtSourceImplGql";
import { ProductosRepositoryImpl } from "../../data/repository/ProductosRepositoryImpl";
import { GetAllProductosUseCase } from "../../bussines/useCases/GetAllProductosUseCase";

export const useProductos = () => {
    const apolloClient = useApolloClient();
    const conceptosDtSourceGql = new ProductosDtSourceImplGql(apolloClient);
    const repository = new ProductosRepositoryImpl(conceptosDtSourceGql);

    const getAllProductos =  async () => {
        const getAllProductosUseCase = new GetAllProductosUseCase(repository);
        const result = await executeUseCase({input: null, useCase: getAllProductosUseCase});
        return result
    };

    return {
        getAllProductos
    };
};